import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaClasificadoresEstadisticos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.clasificadoresEstadisticos,
      textoBuscarNombre: '',
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(
                  `/admin/otros/clasificadoresEstadisticos/${record._id}`
                )
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { clasificadoresEstadisticos } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={false}
        dataSource={clasificadoresEstadisticos}
        title={() => (
          <h2 style={{ textAlign: 'center' }}> Clasificadores Estadisticos </h2>
        )}
        locale={{
          emptyText: 'No hay clasificadores estadisticos cargados',
        }}
      />
    );
  }
}

export default TablaClasificadoresEstadisticos;
